import { render, staticRenderFns } from "./RestartMachine.vue?vue&type=template&id=71fc6790"
import script from "@/scripts/modal/rentalService/restartMachine.js?vue&type=script&lang=js&external"
export * from "@/scripts/modal/rentalService/restartMachine.js?vue&type=script&lang=js&external"
import style0 from "./RestartMachine.vue?vue&type=style&index=0&id=71fc6790&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports